import { FC, ReactNode, useState } from "react";
import Navbar from "Components/Admin/AdminNavbar";
import Sidebar from "Components/Admin/AdminSidebar";

interface LayoutProps {
  children: ReactNode;
  title: string;
  description: string;
}

const Layout: FC<LayoutProps> = ({ children, title, description }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapse = () => setCollapsed(!collapsed);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="h-screen flex bg-[#F8FAFC]">
      <Sidebar
        open={sidebarOpen}
        toggleSidebar={toggleSidebar}
        collapsed={collapsed}
        toggleCollapse={toggleCollapse}
      />
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-30 md:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* RIGHT SIDE AREA */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <Navbar
          toggleSidebar={toggleSidebar}
          collapsed={collapsed}
          toggleCollapse={toggleCollapse}
        />
        {/* Main Content */}
        <main className="flex-1 overflow-y-auto px-8 py-8">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
